import { Injector } from '@angular/core'
import { menuBar } from 'prosemirror-menu'
import { Schema } from 'prosemirror-model'

import { I18nService } from '../../../../../providers/i18n/i18n.service'
import { ModalService } from '../../../../../providers/modal/modal.service'

import { buildMenuItems } from './menu'

export interface CustomMenuPluginOptions {
  floatingMenu?: boolean
  schema: Schema
  injector: Injector
}

export function customMenuPlugin(options: CustomMenuPluginOptions) {
  const modalService = options.injector.get(ModalService)
  const i18nService = options.injector.get(I18nService)
  const pmMenuBarPlugin = menuBar({
    floating: options.floatingMenu !== false,
    content: buildMenuItems(options.schema, modalService, i18nService).fullMenu
  })
  return pmMenuBarPlugin
}
